import { FluidForm } from "../../shared/FluidForm";
import { SimpleFormProvider } from "../fluidComponents/fluidForm/SimpleFormLoader";
import React, { useEffect } from "react";
import { useFluidFormConfigClient } from "../formBuilder/fluidFormConfig.client";
import { AuthLoader } from "../auth/authProvider";
import { UnifiedFluidForm } from "../fluidComponents/fluidForm/unifiedFluidForm/UnifiedFluidForm.component";
import { CodeBlock } from "./CodeBlock";
const basicFormConfig = {
    "type": "form",
    "key": "example-form2",
    "label": "Example Form",
    "description": "",
    "validationStrictness": "strict",
    "fields": [
        {
            "key": "name",
            "label": "Name",
            "type": "fullName",
            "required": true
        },
        {
            "key": "email",
            "label": "Email",
            "type": "email",
            "unique": true,
            "required": true
        },
        {
            "key": "preferences",
            "label": "Preferences",
            "type": "section",
        },
        {
            "key": "birthDate",
            "label": "Birth Date",
            "type": "date"
        },
        {
            "key": "favoriteColor",
            "label": "Colors",
            "type": "multipleOptions",
            "options": [
                {
                    "text": "red",
                    "value": "Red"
                },
                {
                    "text": "blue",
                    "value": "Blue"
                }
            ],
            "fields": []
        },
    ]
};
export function UnifiedFormExample() {
    return (React.createElement("div", { className: "space-y-5" },
        React.createElement("header", null,
            React.createElement("h1", { className: "text-xl font-semibold text-gray-900" }, "Unified Fluid Form"),
            React.createElement("p", { className: "text-gray-600 text-sm mt-1" },
                "Full-page form experience with sections, chat, and validation panels rendered via ",
                React.createElement("code", { className: "px-1 bg-gray-100 rounded" }, "UnifiedFluidForm"),
                ".")),
        React.createElement("section", { className: "space-y-3" },
            React.createElement("h2", { className: "text-sm font-semibold text-gray-800" }, "Usage"),
            React.createElement(CodeBlock, { language: "tsx", code: `<SimpleFormProvider
  render={(formProps, onSubmit, validationResults) => (
    <UnifiedFluidForm {...formProps} onSubmit={onSubmit} validationResults={validationResults} />
  )}
  form={form}
  submissionId=\"example-submission\"
/>` })),
        React.createElement("section", { style: { height: '600px' } },
            React.createElement(AuthLoader, null,
                React.createElement(UnifiedFormExampleContent, null)))));
}
export function UnifiedFormExampleContent() {
    let formConfigClient = useFluidFormConfigClient();
    useEffect(() => {
        /*
          We need to save the Form Config for the AI features to work, as the backend does a security check agains the
          existing configuration.
          This call with only work if the user is authenticated and has the necessary permissions.
        */
        formConfigClient.saveFormConfig({
            formConfig: basicFormConfig,
            formKey: basicFormConfig.key,
            label: basicFormConfig.label
        });
    }, []);
    let form = new FluidForm(basicFormConfig, {
        "name": "Ricardo",
        "email": "ricardodpsx@gmail.",
        "birthDate": "1990-08-23",
        "favoriteColor": ""
    }, {
        styleConfig: {
            inputModes: ["speech", "camera", "fileUpload", "urlCapture"],
            microFormsFieldCount: 1
        }
    });
    return (React.createElement(SimpleFormProvider, { render: (formProps, onSubmit, validationResults) => React.createElement(UnifiedFluidForm, { ...formProps, onSubmit: onSubmit, validationResults: validationResults }), form: form, submissionId: "example-submission" }));
}
